import { jsx as _jsx } from "react/jsx-runtime";
import OrderEntities from 'pages/OrderEntities';
import { Route } from 'react-router';
import AuthorizationService from 'routes/AuthorizationService';
import { Index } from 'constants/actions';
import { OrderEntity as OrderEntityResource } from 'constants/resources';
var OrderEntityRoutes = function () {
    return ([
        _jsx(Route, { caseSensitive: true, path: '/order_entities', element: AuthorizationService.getAuthorizedElement(_jsx(OrderEntities, {}), Index, OrderEntityResource) }, 'order-entities-route')
    ]);
};
export default OrderEntityRoutes;
